var _g, _g2, _path, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 672,
    height: 976,
    viewBox: "0 0 672 976",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_273_2548)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.497 -678.871C405.209 -664.95 573.807 -502.047 787.005 -315.305C1115.3 -27.7486 1357.1 485.875 954.052 677.867C586.573 852.917 486.865 130.774 77.974 141.029C-67.5474 144.678 -145.789 256.226 -286.095 220.938C-463.101 176.42 -550.468 46.6294 -579.599 -125.794C-609.606 -303.397 -550.594 -442.892 -403.301 -557.571C-244.692 -681.06 -88.7644 -688.605 114.497 -678.871Z",
    fill: "#33E8C9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_273_2548)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M560.587 881.089C380.897 1196.64 -76.0331 1173.35 -53.5181 1552.05C-48.9137 1629.5 -41.212 1674.47 -14.5585 1747.29C140.751 2171.61 708.62 1831.42 1013.86 1542.07C1174.14 1390.13 1237.87 1277.03 1337.35 1071.01C1426.69 885.991 1502.96 766.056 1528.16 556.196C1548.75 384.739 1552.47 257.585 1470.39 105.416C1396.01 -32.4789 1312.74 -123.929 1169.38 -139.035C1017.3 -155.059 922.293 -111.631 811.477 -1.70819C583.455 224.476 723.776 594.511 560.587 881.089Z",
    fill: "#00A3FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "hue"
    },
    filter: "url(#filter2_f_273_2548)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M485.93 -1585.99C485.93 -1585.99 786.543 -2055.79 1017.09 -2003.82C1304.63 -1938.99 1085.71 -1272.38 1085.71 -1272.38C1085.71 -1272.38 574.061 -76.9239 419.863 83.2139C175.33 337.166 -97.6105 448.262 -275.903 222.054C-420.656 38.3986 485.93 -1585.99 485.93 -1585.99Z",
    fill: "#00E2BC"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_273_2548)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: -124.196,
    cy: 474.484,
    rx: 164.211,
    ry: 164.252,
    transform: "rotate(78.7148 -124.196 474.484)",
    fill: "#FEFEFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_273_2548",
    x: -1424.11,
    y: -1518.79,
    width: 3425.91,
    height: 3060.95,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 418.46,
    result: "effect1_foregroundBlur_273_2548"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_273_2548",
    x: -891.241,
    y: -979.176,
    width: 3268.79,
    height: 3763.11,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 418.46,
    result: "effect1_foregroundBlur_273_2548"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_273_2548",
    x: -1128.48,
    y: -2844.75,
    width: 3130.87,
    height: 4026.16,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 418.46,
    result: "effect1_foregroundBlur_273_2548"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_273_2548",
    x: -640.127,
    y: -41.4091,
    width: 1031.86,
    height: 1031.79,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 175.825,
    result: "effect1_foregroundBlur_273_2548"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginGradient);
export default __webpack_public_path__ + "static/media/loginGradient.b4380c9a6779931db487fadef3268272.svg";
export { ForwardRef as ReactComponent };